import { Layout } from '@abyss/web/ui/Layout';
import { Text } from '@abyss/web/ui/Text';

type UndoActionProps = {
  providerName?: string;
  message?: string;
};

export const UndoAction = ({ providerName, message }: UndoActionProps) => (
  <Layout.Stack alignItems="left">
    <Text
      color="$white"
      data-testid="remove-care-team-action-alert"
      fontWeight={700}
    >{`${providerName} ${message}`}</Text>
  </Layout.Stack>
);
